import { v1 as uuid } from 'uuid';
import { AnswerOption } from '../../../../../../types';

export const createEmptyAnswer = (): AnswerOption => ({
  _id: uuid(),
  value: ''
});
